export default __webpack_public_path__ + "static/media/outfit.29eb266b.svg";